<template>
    <div class="pb50">
        <div>
            <el-button size="small" icon="el-icon-plus" @click="addCoupon()">选择优惠券</el-button>
        </div>
        <el-table size="small" :data="list" style="width: 100%" v-loading="loading">
            <el-table-column prop="coupon_name" label="优惠券">
                <template slot-scope="scope">
                    <span class="fb orange">{{ scope.row.coupon_name }}</span>
                </template>
            </el-table-column>


            <el-table-column prop="coupon_id" label="优惠券ID" width="70"></el-table-column>
            <el-table-column prop="coupon.coupon_type.text" label="类型"></el-table-column>
            <el-table-column prop="coupon.min_price" label="最低消费金额"></el-table-column>
            <el-table-column prop="coupon.seckill_stock" label="优惠方式">
                <template slot-scope="scope">
                    <div v-if="scope.row.coupon.coupon_type.value == 10">
                        <span><strong class="orange">{{ scope.row.coupon.reduce_price }}</strong> 元</span>
                    </div>
                    <div v-if="scope.row.coupon.coupon_type.value == 20">
                        <span><strong class="orange">{{ scope.row.coupon.discount }}</strong> 折</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="coupon.seckill_stock" label="有效期">
                <template slot-scope="scope">
                    <div v-if="scope.row.coupon.expire_type == 10">
                        <span>领取 <strong>{{ scope.row.coupon.expire_day }}</strong> 天内有效</span>
                    </div>
                    <div v-if="scope.row.coupon.expire_type == 20">
                        <span>{{ scope.row.coupon.start_time.text }} ~ {{ scope.row.coupon.end_time.text }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="coupon.receive_num" label="赠送数量">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.coupon_num" type="number" :min="1" :step="1" @change="couponNumChange($event, scope.row)"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="coupon.receive_num" label="发放总数量">
                <template slot-scope="scope">
                    <span>{{ scope.row.coupon.total_num === -1 ? '不限制' : scope.row.coupon.total_num }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="coupon.receive_num" label="已领取数量"></el-table-column>

            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="editCoupon(scope.row)">编辑优惠券</el-button>
                    <el-button type="text" size="small" @click="deleteCoupon(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--选择优惠券-->
        <GetCoupon v-if="open_add" :open_add="open_add" @closeDialog="closeGoodsDialogFunc($event)">选择优惠券弹出层</GetCoupon>
    </div>
</template>
<script>
    import GoodsApi from "@/api/goods.js";
    import GetCoupon from "@/components/coupon/GetCoupon";
    export default {
        components: {
            GetCoupon
        },
        data () {
            return {
                goods_id: '',
                list: [],
                /*是否加载完成*/
                loading: false,
                /*添加优惠券*/
                open_add: false,
                form: {
                    goods_id   : '',
                    coupon_id  : '',
                    coupon_num  : 1,
                },
            };
        },
        created() {
            this.goods_id = this.$route.query.goods_id;
            this.form.goods_id = this.$route.query.goods_id;
            this.getData();
        },
        methods: {
            couponNumChange(e, row){
                this.form = row;
                this.form.coupon_num = e;
                this.onSubmit();
            },
            /*添加优惠券*/
            addCoupon() {
                this.open_add = true;
            },
            /*关闭弹窗*/
            closeGoodsDialogFunc(e) {
                this.open_add = e.openDialog;
                if (e.type == "success") {
                    this.form = {};
                    this.form.goods_id = this.$route.query.goods_id;
                    this.form.coupon_id = e.params.coupon_id;
                    this.form.coupon_num = 1;
                    this.onSubmit();
                }
            },
            /*获取数据*/
            getData() {
                let self = this;
                this.loading = true;
                GoodsApi.getCoupon({goods_id:this.goods_id})
                    .then((res) => {
                        self.loading = false;
                        self.list = res.data.list;
                    })
                    .catch((error) => {});
            },

            /*修改*/
            onSubmit () {
                let self = this
                let params = this.form
                self.loading = true
                GoodsApi.editCoupon(params, true)
                    .then((res) => {
                        self.loading = false
                        self.$message.success(res.msg)
                        self.getData()
                    })
                    .catch((error) => {
                        self.loading = false
                    })
            },
            /*删除优惠券*/
            deleteCoupon (row) {
                let self = this
                self.$confirm('确定删除该优惠券?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText : '取消',
                    type             : 'warning'
                }).then(() => {
                    self.loading = true
                    GoodsApi.delCoupon({ goods_coupon_id: row.goods_coupon_id }, true).then((data) => {
                        self.loading = false
                        self.$message({
                            message: data.msg,
                            type   : 'success'
                        })
                        self.getData()
                    })
                })
            },

            editCoupon(row) {
                this.$router.push({
                    path: "/coupon/coupon/edit",
                    query: {
                        coupon_id: row.coupon_id,
                    }
                });
            },
        }
    };
</script>

<style>
    .reward-list .reward-item {
        margin-bottom: 10px;
        padding: 10px 20px;
        border: 1px solid #ebeef5;
    }

    .reward-list .delete-reward {
        position: absolute;
        top: 10px;
        right: 20px;
        cursor: pointer;
        z-index: 10;
    }
</style>



// WEBPACK FOOTER //
// src/views/goods/goods/coupon.vue